import { Fragment, type ReactNode } from 'react'
import { cx } from '../utils/cx'

export function CtxMeta({ items, className }: { items: { k: ReactNode; v: ReactNode }[]; className?: string }) {
  return (
    <div className={cx('st-ctx-meta', className)}>
      {items.map((it, i) => (
        <Fragment key={i}>
          <b>{it.k}</b>
          <span>{it.v}</span>
        </Fragment>
      ))}
    </div>
  )
}
